import React, { useEffect,useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useParams,useNavigate } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import Input from '../Common/Input';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from 'moment-jalali';
import { toast } from 'react-toastify';

const Contract = () => {

    const { id } = useParams();
    const {addData: createContract} = useEntityCrud('Contract/SetContract');
    const {readData: getContracts} = useEntityCrud('Contract/GetAllContract?BusinessId=' + id)
    const [contracts,setContracts] = useState([]);
    const {readData: getBusiness} = useEntityCrud('Business/GetBusiness?BusinessId=' + id);
    const [business,setBusiness] = useState({});
    const navigate = useNavigate();

    const getData = () => {
        getContracts().then(({data}) => {
            if(data.status)
                setContracts(data.result);
        });
    }
    
    useEffect(() => {
        getBusiness().then(({data}) => {
            if(data.status)
                setBusiness(data.result);
        })
        getData();
    },[])

    const convertToDate = date => {
        console.log(date);
        if(!date)
            return '';
        return moment(`${date.year}/${date.month}/${date.day}`,'jYYYY/jMM/jDD').format('jYYYYjMMjDD');
    }

    const initialValues = {
        startDate: '',
        endDate: '',
        contractTitle: '',
        sharePercentage: ''
    };
    
    const validationSchema = Yup.object({
        contractTitle: Yup.string()
        .required(),
        startDate: Yup.string()
        .required(),
        endDate: Yup.string()
        .required(),
        sharePercentage: Yup.number()
        .required()
    });
    
    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            contractTitle: values.contractTitle,
            startDate: values.startDate,
            endDate: values.endDate,
            sharePercent: values.sharePercentage,
            businessId: id
       };
       createContract(postedData).then(({data}) => {
            if(data.status){
                getData();
                formik.setValues({
                    startDate: '',
                    endDate: '',
                    contractTitle: '',
                    sharePercentage: ''
                });
                toast.success('قرارداد جدید با موفقیت در سیستم ثبت گردید');
            }else
                data.errors.map(error => toast.error(error.message));
       }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
       
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/organizations',{replace: true});
    }

    useEffect(() => {
        console.log(formik.values.startDate);
    },[formik.values])

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">قرارداد های {Object.keys(business).length ? business.title : ''}</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <Input label="عنوان قرارداد" name="contractTitle" required={true} formik={formik} />
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>تاریخ شروع</label>
                                <DatePicker
                                    name="startDate"
                                    required
                                    locale="fa"
                                    shouldHighlightWeekends
                                    value={formik.values.startDate ? {year: formik.values.startDate.toString().slice(0,4),month: formik.values.startDate.toString().slice(4,6),day: formik.values.startDate.toString().slice(6,8)} : ''}
                                    calendarPopperPosition={'bottom'}
                                    onChange={(value) => {
                                        formik.setFieldValue('startDate',parseInt(convertToDate(value)))
                                    }}
                                    inputClassName={formik.errors['startDate'] ? 'form-control ltr-input is-invalid' : 'form-control ltr-input'}
                                    inputPlaceholder=' '
                                />
                                {formik.errors['startDate'] && (
                                    <small className="text-danger">{formik.errors['startDate']}</small>
                                )}
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>تاریخ اتمام</label>
                                <DatePicker
                                    name="endDate"
                                    required
                                    locale="fa"
                                    shouldHighlightWeekends
                                    value={formik.values.endDate ? {year: formik.values.endDate.toString().slice(0,4),month: formik.values.endDate.toString().slice(4,6),day: formik.values.endDate.toString().slice(6,8)} : ''}
                                    calendarPopperPosition={'bottom'}
                                    onChange={(value) => {
                                        formik.setFieldValue('endDate',parseInt(convertToDate(value)))
                                    }}
                                    inputClassName={formik.errors['endDate'] ? 'form-control ltr-input is-invalid' : 'form-control ltr-input'}
                                    inputPlaceholder=' '
                                />
                                {formik.errors['endDate'] && (
                                    <small className="text-danger">{formik.errors['endDate']}</small>
                                )}
                            </div>
                        </div>
                        <div className="col-md-2">
                            <Input label="درصد تسهیم" name="sharePercentage" required={true} formik={formik} isLtr={true} type="number" max={100} min={0} />
                        </div>
                    </div>
                    <button className="btn btn-success" id="btn-submit-form">ذخیره اطلاعات</button>
                </form>
                {contracts.length ? 
                <>
                <hr />
                <h5>لیست قرارداد ها</h5>
                <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>تاریخ شروع</th>
                            <th>تاریخ پایان</th>
                            <th>درصد تسهیم</th>
                        </tr>
                    </thead>
                    <tbody>
                        {contracts.map((contract,index) => (
                            <tr key={index} className={index == 0 ? 'bg-success' : ''}>
                                <td>{index + 1}</td>
                                <td>{contract.contractTitle}</td>
                                <td>{contract.startDate.toString().slice(0,4) + '/' + contract.startDate.toString().slice(4,6) + '/' + contract.startDate.toString().slice(6,8)}</td>
                                <td>{contract.endDate.toString().slice(0,4) + '/' + contract.endDate.toString().slice(4,6) + '/' + contract.endDate.toString().slice(6,8)}</td>
                                <td>{contract.sharePercent}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                </>
                : ''}
            </div>
        </div>
    );
}

export default Contract;